import "./index.css";
import { clsx } from "clsx";
import type { ReactNode } from "react";
import { Text } from "@/ui-kit";

type IProps = {
  title: string;
  children: ReactNode;
  className?: string;
};

export const FormSection = ({ title, children, className }: IProps) => {
  return (
    <div className={clsx("form-section", className)}>
      <header className="form-section__header">
        <Text size="lg" weight="bold" className="form-section__title">
          {title}
        </Text>
      </header>
      <div className="form-section__content">{children}</div>
    </div>
  );
};
